import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { NavigationService } from '../../../shared/services/navigation.service';

@Component({
  selector: 'app-bet-success',
  templateUrl: './bet-success.component.html',
  styleUrls: ['./bet-success.component.scss']
})
export class BetSuccessComponent {

  status: any = '';
  supportLanguages = ['en', 'my', 'th', 'zh', 'my_zawgyi'];
  
  constructor(
    public navigation: NavigationService,
    private Location: LocationStrategy,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private storage: LocalStorageService) {
    
    this.status = history.state.status;
  }
  

  openHomePage() {  
    //Test
    //this.storage.store('localSelectTwoDList',null);
    this.navigation.goBack(); //original
    //this.router.navigate([`/${this.activatedRoute.snapshot.parent.routeConfig.path}/init`], {replaceUrl : true})
  }
}
